import { styled } from '@mui/material/styles';
import { ListItemButton } from '@sunwisesoftware/sunwise-ui';

export default styled(ListItemButton)(({ theme, drawersize }) => ({
    alignItems: 'center',
    color: '#fff',
    display: 'flex',
    gap: '8px',
    borderRadius: '8px',
    '& svg': { height: '20px', width: '20px' },
    '& svg path': { fill: '#848bab' },
    '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: '#224156',
    },
    '& .MuiListItemText-root': { margin: 0 },
    ...(drawersize === 'small' && {
        [theme.breakpoints.up('md')]: {
            '& .MuiListItemText-root': { visibility: 'hidden' },
        },
    }),
}));
